<template>
    <v-dialog 
        :value="true"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="showCancelDialogConfirm = true">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span>Department Code Rates</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-layout class="dialog-content">
                <v-flex xs12 mt-4>
                    <v-layout wrap>
                        <v-data-table
                            :headers="headers"
                            hide-actions
                            :items="rates"
                            :loading="loading"
                        >
                            <template v-slot:items="{ item, index }">
                                <td>{{ moment(item.EffectiveDate).format('YYYY-MM-DD') }}</td>
                                <td>{{ item.MinimumRateLevel1.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}</td>
                                <td>
                                    <template v-if="item.SupervisorPayRate == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.SupervisorPayRate.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.AssistantPayRate == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.AssistantPayRate.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.PickerPayRate == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.PickerPayRate.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.PickerPayRate2 == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.PickerPayRate2.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.MaxPieceRate == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.MaxPieceRate.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                <td>
                                    <template v-if="item.SupervisorPayRateInclAllowance == null || ''">n/a</template>
                                    <template v-else>
                                        {{ item.SupervisorPayRateInclAllowance.toLocaleString("en-AU", {style:"currency", currency:"AUD"})  }}
                                    </template>
                                </td>
                                <td>
                                    <v-btn icon @click="handleEditRate(item, index)" small>
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="handleDeleteRate(item, index)" small>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                            <template v-slot:footer>
                                <td :colspan="8">
                                    <v-btn 
                                        color="primary" 
                                        @click="handleAddRate()">
                                        <span>New Rate</span>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :loading="saving" 
                                @click="save">
                                <span>Save & Close</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="saving" 
                                @click="showCancelDialogConfirm = true">
                                <span>Cancel & Close</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-alert 
                                :value="error" 
                                outline 
                                type="error">
                                <span>{{ error }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
        <departmentCodeRateAddEdit :rate="editRate" :show="displayRateEdit" :maximumRate="maximumRate" @cancel="handleRateEditCancel" @confirm="handleRateEditConfirm"></departmentCodeRateAddEdit>
        <yes-no-popup 
            :DisplayDialog="showDeleteDialogConfirm" 
            :DialogTitle="'Delete Rate'" 
            :DialogContents="'Are you sure you want to delete this rate?'" 
            @No="handleDeleteRateCancelled" 
            @Yes="handleDeleteRateConfirmed" />
        <yes-no-popup 
            :DisplayDialog="showCancelDialogConfirm" 
            :DialogTitle="'Cancel all Changes'" 
            :DialogContents="'Are you sure you want to cancel all changes?'" 
            @No="showCancelDialogConfirm = false" 
            @Yes="ClosePopup" />
    </v-dialog>
</template>


<script>
import depatmentCodeRateApi from "@/api/depatmentCodeRateApi";
import configurationApi from "@/api/configurationApi";
import BaseAPI from "@/api/baseApi";
import moment from "moment";
import * as Constants from "@/helpers/constants";
import UtilService from '@/services/utilService.js';
import departmentCodeRateAddEdit from "./departmentCodeRateAddEdit.vue";
import YesNoPopup from '@/components/generic/YesNoPopup.vue';

export default {
    props: {
    },
    components: {
        departmentCodeRateAddEdit,
        YesNoPopup
    },
    data() {
        return {
            moment,
            saving: false,
            loading: true,
            error: null,
            showCancelDialogConfirm: false,
            showDeleteDialogConfirm: false,
            rates: [],
            editRate: null,
            editIndex: -1,
            displayRateEdit: false,
            maximumRate: 100,
            headers: [
                {
                    text: "Effective Date",
                    value: "EffectiveDate",
                    sortable: false
                },
                {
                    text: "Minimum Level 1",
                    value: "MinimumRateLevel1",
                    sortable: false
                },
                {
                    text: "Supervisor",
                    value: "SupervisorPayRate",
                    sortable: false
                },
                {
                    text: "Assistant",
                    value: "AssistantPayRate",
                    sortable: false
                },
                {
                    text: "Picker Hrly Rate",
                    value: "PickerPayRate",
                    sortable: false
                },
                {
                    text: "Piece Rate Competency Hrly Rate",
                    value: "PickerPayRate2",
                    sortable: false
                },
                {
                    text: "Maximum Piece Rate",
                    value: "MaxPieceRate",
                    sortable: false
                },
                {
                    text: "Supervisor Incl Allowance",
                    value: "SupervisorPayRateInclAllowance",
                    sortable: false
                },
                {
                    text: "",
                    value: "Edit",
                    sortable: false
                }
            ],
        }
    },
    computed: {
        departmentCodeID() {
            if(this.$route.params.departmentCodeID == null || this.$route.params.departmentCodeID == undefined) {
                return -1;
            }
            return parseInt(this.$route.params.departmentCodeID);
        },
        defaultRate() {
            return  {
                DepartmentCodeID: this.departmentCodeID,
                EffectiveDate: new Date(),
                MinimumRateLevel1: 0,
                SupervisorPayRate: 0,
                AssistantPayRate: 0,
                PickerPayRate: 0,
                PickerPayRate2: 0,
                MaxPieceRate: 0,
                SupervisorPayRateInclAllowance: 0
            }
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        handleAddRate(){
            var newIndex = this.rates.length;
            // open edit dialog
            this.handleEditRate(this.defaultRate, newIndex);
        },
        handleEditRate(item, index){
            this.displayRateEdit = true;
            this.editIndex = index;
            this.editRate = item;
        },
        handleDeleteRate(item, index) {
            this.showDeleteDialogConfirm = true;
            this.editIndex = index;
        },
        handleDeleteRateConfirmed(){
            this.rates.splice(this.editIndex, 1);
            this.editIndex = -1;
            this.showDeleteDialogConfirm = false;
        },
        handleDeleteRateCancelled(){
            this.showDeleteDialogConfirm = false;
            this.editIndex = -1;
        },
        handleRateEditCancel(rate){
            this.displayRateEdit = false;
            this.editIndex = -1;
            this.editRate = null;
        },
        handleRateEditConfirm(rate){
            // convert the decimal strings to numbers
            rate.MinimumRateLevel1 = parseFloat(rate.MinimumRateLevel1);
            rate.AssistantPayRate = (rate.AssistantPayRate == null || rate.AssistantPayRate == '') ? null : parseFloat(rate.AssistantPayRate);
            rate.MaxPieceRate = (rate.MaxPieceRate == null || rate.MaxPieceRate == '') ? null : parseFloat(rate.MaxPieceRate);
            rate.PickerPayRate = (rate.PickerPayRate == null || rate.PickerPayRate == '') ? null : parseFloat(rate.PickerPayRate);
            rate.PickerPayRate2 = (rate.PickerPayRate2 == null || rate.PickerPayRate2 == '') ? null : parseFloat(rate.PickerPayRate2);
            rate.SupervisorPayRate = (rate.SupervisorPayRate == null || rate.SupervisorPayRate == '') ? null : parseFloat(rate.SupervisorPayRate);
            rate.SupervisorPayRateInclAllowance = (rate.SupervisorPayRateInclAllowance == null || rate.SupervisorPayRateInclAllowance == '') ? null : parseFloat(rate.SupervisorPayRateInclAllowance);
            
            this.$set(this.rates, this.editIndex, rate);
            this.rates[this.editIndex] = rate;
            this.handleRateEditCancel();
        },
        validate(){
            const Dates = Object.groupBy(this.rates, (d) => { 
                return UtilService.formatDateYMD(d.EffectiveDate)
            });
            const DateKeys = Object.keys(Dates);
            if(DateKeys.length != this.rates.length){
                this.error = 'Effective Date must be unique';
                return false;
            }
            return true;
        },
        async save() {
            try {
                if(!this.validate()){
                    return;
                }
                this.saving = true;
                this.error = null;
                var response = await depatmentCodeRateApi.saveDepartmentCodeRates(this.rates);
                if(response != undefined && !response.Success){
                    console.log('error', response.ErrorMessages);
                    this.error = response.ErrorMessages.join(', ');
                    this.loadData();
                }
                else {
                    this.ClosePopup();
                }
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        },
        async loadData() {
            try {
                this.loading = true;
                this.rates = await depatmentCodeRateApi.getDepartmentCodeRates(this.departmentCodeID);
                this.maximumRate = await depatmentCodeRateApi.getDepartmentCodeMaxRate(this.departmentCodeID);
            }
            catch(err){
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.loading = false;
            }
        },
        ClosePopup() {
            try {
                parent.CloseRadWindow();
            } catch (err) {
                this.DialogText = 'An error has occured while updating this location. Please try again.';
                this.DisplayDialog = true;
                this.Loading = false;
                console.log(err.toString());
            }
        }
    },
    watch: {
    },
}
</script>